<template>
  <div>
    <div class="popFixed">
      <div class="masking" />
      <div
        class="fixed-fullpage-wrapper"
        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
      >
        <div class="fullpage-wrapper-title">交易及存取款注意事项</div>
        <div class="sub-wrapper">
          <!-- <span> -->
          您好，感谢您加入我司平台，以下有几个重要的交易事项给您说明，关系您的交易权益，大约耽误您5分钟的时间，请您仔细查看。
          <br><br>
          <ol class="text-clipping" style="list-type: number;" type="1">
            <li>
              1.⁠ ⁠您在平台上所做的交易都默认是您本人操作，千万不要将账户交由他人代为交易；也建议定期更改密码，确保账户安全。
            </li>
            <li>
              2.⁠ ⁠取款方面有三个情况会收手续费：
              <ol>
                <li>
                  (1) 单笔取款50美元以下，公司收取3美元作为手续费；
                </li>
                <li>
                  (2) 若交易量不足总注资金额60%，或是最后一次注资金额未用于投资交易，公司将收取取款金额6%作为手续费；(若交易量、最后一次注资金额未达成，仅扣一次6%手续费)
                </li>
                <li>
                  (3) 每24小时内第3笔(包含第3笔)后的取款，公司将收取取款金额4%作为手续费；
                </li>
              </ol>
              <br>
              <p>
                上述三点若都未达成，将叠加收取三项的手续费用。但请您不用担心，取款最终都会主动提示您是否收取手续费，请您多加留意。
              </p>
            </li>
            <li>
              3.⁠ ⁠我司强制平仓水平平日是40%，周末收市前30分钟会提高到200%(股票为100%)。另外部份美股于业绩公布日，前一个营业日休市前30分钟会提高至200%~400%不等。建议您操作时务必留意风险控管，并且轻仓操作、设置止盈止损，而商品都有杠杆，交易时建议最多拿您帐户资金的10%来建仓即可，止损金额设置为您可承受的范围内，切勿亏损加仓或是摊平操作，此外止盈止损是当周有效，过周、或是过假期未触发的话则需重新设定。
            </li>
            <li>
              4.⁠ ⁠交易时可能出现滑点，即下单价格与最终成交价格存在差异。当市场出现剧烈波动、价格跳空或流动性不足时，例如重大数据公布前后、休市前或刚开盘时，若市场上没有客户设置的价格，订单可能按照下一口可成交的市场价格执行。因此，止盈止损也可能出现滑点，实际成交价格可能优于或劣于预期价格，请您交易时务必留意相关风险。
            </li>
            <li>
              5.⁠ ⁠我司平台期货商品有原油、指数、天然气、农产品 、铜、铁、股票股指等，合约到期当下会按照交易所合约的结算价强制平仓；另外股票净除日也会强制平仓，建议您务必留意强平的日期提前平仓。若持仓过夜，会产生过夜利息，夏令时是北京时间早上5点、冬令时是北京时间早上6点，只要持仓超过这个结算时间就会收取。此外周四会按照国际惯例收取三天的过夜费，建议您周三晚上睡前请务必留意。
            </li>
            <li>
              6.⁠ ⁠如果您有参加新客户赠金活动, 请留意活动期间内会暂时无法取款，若要取款，只要在空仓且没有挂单的时候向在线客服申请结算，结算会扣除未完成手数的赠金，之后即可正常取款。
            </li>
          </ol>
          <br>
          <p>
            最后以上说明的内容可以于官网下方[交易事项]查看。如有任何疑问, 欢迎随时联系我们在线客服查询，感谢您耐心查看。
          </p>
          <!-- </span> -->
        </div>
        <div class="wrapper-controls">
          <div class="control-item" style="position: relative;">
            <p v-if="loadingSource" style="width: 100%">
              加载录音中...请稍候
            </p>
            <input
              ref="audioProgress"
              type="range"
              class="control-progress"
              :class="{ 'is-active': !loadingSource }"
              max="100"
              :value="progressValue"
              @change="changeProgressPointer"
            >
            <span class="audio-current-time" style="margin-left: 0.2rem">{{
              convertSecondToMinsFormat(progressValue)
            }}</span>
            /
            <span class="audio-total-time">{{
              duration ? convertSecondToMinsFormat(duration) : "00:00"
            }}</span>
          </div>
          <div class="control-item" style="justify-content: flex-start">
            <button
              type="button"
              class="control-button"
              style="margin-left: 0"
              :class="{ disabled: loadingSource }"
              @click="playOrPauseAudio"
            >
              {{ playing ? "暂停" : "收听录音" }}
            </button>
            <button
              type="button"
              class="control-button"
              :class="{ disabled: loadingSource }"
              @click="speedUp"
            >
              {{ isSpeedUp ? "正常" : "快速" }}
            </button>
          </div>
          <div class="control-item">
            <input
              ref="readAudio"
              type="checkbox"
              class="control-checkbox"
              name="readAudio"
              @click="checkMe"
            >
            <label
              for="readAudio"
              @click="checkRead"
            >&nbsp;&nbsp;已阅读以上内容</label>
          </div>
          <div class="control-item" style="justify-content: center">
            <button
              type="button"
              :class="{ disabled: disabled }"
              class="control-button rounded-button"
              @click="submitRead"
            >
              确定
            </button>
          </div>
          <div class="abolute-button">
            <img
              src="@/assets/images/template/cs_24.png"
              style="height: 1.2rem; max-height: 90px"
              @click="openLive800"
            >
          </div>
        </div>
        <audio
          ref="audioSource"
          src="https://dl.cfxz123.com/source/material/disclosure.mp3"
          type="audio/mpeg"
          preload="metadata"
        />
      </div>
    </div>
    <div v-if="showError" class="popFixed">
      <div class="masking" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>{{ errorText }}</p>
        </div>
        <div class="btnCon only">
          <span>了解</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/plugins/api'
export default {
  name: 'DisclosureAudio',
  props: {
    readDisclosure: {
      require: true,
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      loadingSource: true,
      disabled: true,
      playing: false,
      isSpeedUp: false,
      showError: false,
      errorText: '状态更新失败，请联络客服！',
      updateInterval: 1000,
      progressValue: 0,
      duration: 0
    }
  },
  mounted() {
    const isIos =
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    if (isIos) {
      this.loadingSource = false
    }
    this.$refs.audioSource.onloadedmetadata = () => {
      this.loadingSource = false
      this.$refs.audioProgress.setAttribute(
        'max',
        Math.ceil(this.$refs.audioSource.duration)
      )
      this.duration = Math.ceil(this.$refs.audioSource.duration)
      this.$refs.audioSource.addEventListener('ended', () => {
        setTimeout(() => {
          this.playing = false
          this.progressValue = 0
        }, 1000)
      })
    }
  },
  methods: {
    openLive800() {
      var url =
      `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = screen.width / 2 - 600 / 2
      var top = screen.height / 2 - 400 / 2
      window.open(
        url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' +
          top +
          ', left=' +
          left
      )
    },
    checkMe() {
      this.disabled = !this.$refs.readAudio.checked
    },
    // accept the agreement
    checkRead() {
      this.$refs.readAudio.checked = !this.$refs.readAudio.checked
      this.disabled = !this.$refs.readAudio.checked
    },
    // play the audio
    playOrPauseAudio() {
      if (this.loadingSource) return
      const source = this.$refs.audioSource
      if (source.paused) source.play()
      else source.pause()
      this.playing = !this.playing
      if (this.playing) this.updateProgress()
    },
    // speed up the audio playback rate
    speedUp() {
      if (this.loadingSource) return
      this.isSpeedUp = !this.isSpeedUp
      this.updateInterval = this.isSpeedUp ? 1000 / 1.5 : 1000
      this.$refs.audioSource.playbackRate = this.isSpeedUp ? 1.5 : 1
    },
    // update the input range value
    updateProgress() {
      setTimeout(() => {
        const value = this.progressValue + 1
        if (value > this.$refs.audioSource.duration) return
        this.progressValue = value
        if (this.playing) this.updateProgress()
      }, this.updateInterval)
    },
    changeProgressPointer(evt) {
      if (!this.playing) {
        this.playOrPauseAudio()
      }
      this.progressValue = Number(evt.target.value)
      this.$refs.audioSource.currentTime = Number(evt.target.value)
    },
    convertSecondToMinsFormat(seconds) {
      const mins = Math.floor(seconds / 60)
      const second = Math.round(seconds % 60)
      return `${('0' + mins).slice(-2)}:${('0' + second).slice(-2)}`
    },
    submitRead() {
      /**
       * @param {(-1|0|1|2)} remindRisk
       * -1: error
       * 0: 不需阅读
       * 1: 未阅读
       * 2: 已阅读
       */
      if (this.disabled) return
      const remindRisk = '2'
      api
        .updateRemindRisk(this.$qs.stringify({ remindRisk: remindRisk }))
        .then((res) => {
          if (res.data.code === 200) {
            this.readDisclosure()
          } else {
            this.errorText = '状态更新失败，请联络客服！'
            this.showError = true
            setTimeout(() => {
              this.readDisclosure()
            }, 3000)
          }
        })
        .catch(() => {
          this.showError = true
          this.errorText = '网络发生错误，请联络客服！'
          setTimeout(() => {
            this.readDisclosure()
          }, 3000)
        })
    }
  }
}
</script>
